// What the consent runtime loads and where, in one place so the loaders, the
// admin readout and the tests cannot disagree about it.

/** The GA4 property for wanderlustcravings.com. */
export const GA_MEASUREMENT_ID = 'G-0XWFP5LLR0';

/** Metricool's id for this site. */
export const METRICOOL_HASH = 'e72ac083d6ddf3f57741713bbc91a6ef';

/**
 * The hosts the trackers run on. Google Analytics records whatever host it runs
 * on, so without this a dev server, a workspace build or a .fly.dev preview
 * files its visits under the real site's numbers. `.travel` 301s to `.com` at
 * the Fly edge today; it is listed for the day it is served directly, because a
 * host that is served but missing here silently stops being counted.
 */
export const TRACKED_HOSTS: readonly string[] = ['wanderlustcravings.com', 'wanderlustcravings.travel'];

/**
 * How long the GA cookies last, in seconds: 13 months, the longest the EU's
 * regulators accept for an analytics cookie. GA's own default is two years.
 */
export const GA_COOKIE_MAX_AGE_SECONDS = 13 * 30 * 24 * 60 * 60;
